exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".heading[data-v-3786b1d5]{margin-bottom:20px;font-family:Open Sans,sans-serif;font-size:.85em;text-transform:uppercase;color:#252525}@media only screen and (min-width:475px){.heading[data-v-3786b1d5]{font-size:1.06em}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3786b1d5","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/profile/views/progress/forms/components/heading/Heading.vue
// module id = dd9820f257f8dd173efb
// module chunks = 0